const mutations = {
    SET_SHOW_FB_CHAT: (state,payload) => {
        state.showFbChat = payload;
    }
};
  
export default mutations;